import { SITE } from "../../lib/site";

const SECTIONS = [
  {
    icon: "🛫", title: "Your Favorite Airports",
    body: "Start with the airports closest to you and the airports you use most. Save your home airport and nearby airports, then add more of your favorites — up to 20 airports — with quick links to their airport pages.",
  },
  {
    icon: "✈️", title: "Your Favorite Airlines",
    body: "Keep the airlines you fly most within reach. Save up to 20 favorite airlines and quickly explore their information, routes and services.",
  },
  {
    icon: "📍", title: "Your Travel Location & Weather",
    body: "Keep your city and country up to date and see relevant weather information for your location and travel planning.",
  },
  {
    icon: "🟢", title: "Check Flight Status",
    body: "Searching for a flight? Use Flight Status to quickly check the latest available information for your journey and stay informed about changes.",
  },
  {
    icon: "📝", title: "Your Travel Notes — for you and your family",
    body: "Turn My Travel Hub into your personal travel journal. Create notes for every trip with:",
    list: ["Trip title and description", "Airline and booking/reference code", "Boarding Passes", "Travel dates", "Screenshots and photos", "Personal notes and comments", "Important travel details"],
    after: "Keep everything organized in one place instead of searching through emails, text messages and phone screenshots.",
  },
  {
    icon: "📲", title: "Share When You Choose",
    body: "Need to send a trip detail to someone traveling with you? Share selected travel information through WhatsApp, email or text message directly from your phone. Your travel information stays private unless you choose to share it.",
  },
  {
    icon: "🌎", title: "Build Your Travel History",
    body: "Over time, My Travel Hub can become more than a travel organizer — it can become your personal record of the places you've been, the airlines you've flown, the airports you've discovered and all other memories you've made.",
  },
];

export default function HubIntro() {
  return (
    <article data-testid="hub-intro" className="max-w-3xl">
      <div className="text-xs font-mono uppercase tracking-widest text-primary mb-2">✈️ My Travel Hub</div>
      <h2 className="font-heading font-900 text-3xl sm:text-4xl tracking-tight leading-tight">
        Your airports. Your airlines. Your journeys — all in one place.
      </h2>
      <p className="mt-4 text-[16px] leading-relaxed text-zinc-700">
        My Travel Hub is your personal travel space on <span className="font-600">{SITE.brandLabel}</span> —
        designed to help you organize the airports and airlines you love, follow your flights, and keep a record of the journeys that matter to you and your family.
      </p>

      <div className="mt-8 space-y-6">
        {SECTIONS.map((s) => (
          <div key={s.title} className="border-l-4 border-primary/30 pl-4">
            <h3 className="font-heading font-700 text-lg flex items-center gap-2"><span aria-hidden>{s.icon}</span> {s.title}</h3>
            <p className="mt-1 text-base leading-relaxed text-zinc-700">{s.body}</p>
            {s.list && (
              <ul className="mt-2 grid sm:grid-cols-2 gap-x-6 gap-y-1 list-disc pl-5 text-base text-zinc-700">
                {s.list.map((li) => <li key={li}>{li}</li>)}
              </ul>
            )}
            {s.after && <p className="mt-2 text-base leading-relaxed text-zinc-700">{s.after}</p>}
          </div>
        ))}
      </div>

      <div className="mt-8 border border-zinc-300 bg-zinc-50 p-5">
        <div className="font-heading font-900 text-xl">One Hub. Every Journey.</div>
        <p className="mt-1 text-base text-zinc-700">Save your favorites. Follow your flights. Organize your trips. Keep your memories.</p>
        <p className="mt-2 text-primary font-600">My Travel Hub — Your journey, organized.</p>
      </div>
    </article>
  );
}
